import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  priceBreakdownTable: {
    '& td': {
      borderBottom: 'none',
      padding: theme.spacing(4, 0),
      display: 'flex',
      justifyContent: 'space-between'
    },
    '& tr': {
      borderBottom: `1px solid ${theme.colorPalette.beige_25_op_30}`
    },
    '& tr:first-of-type > td': {
      paddingTop: 0
    },
    '& tr:last-of-type': {
      borderBottom: 'none',
      '& > td': {
        paddingBottom: 0
      }
    }
  },
  inaccurateValueNote: {
    color: 'red'
  },
  container: {
    backgroundColor: theme.colorPalette.green_100,
    margin: theme.spacing(4, 0),
    padding: theme.spacing(6)
  },
  label: {
    display: 'flex',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    lineHeight: 1.33,
    fontSize: 12,
    textTransform: 'uppercase',
    color: theme.colorPalette.beige_50,
    alignItems: 'center'
  },
  value: {
    display: 'flex',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    lineHeight: 1.2,
    fontSize: 20,
    color: theme.colorPalette.beige_50
  },
  tooltip: {
    position: 'relative',
    margin: theme.spacing(0, 1)
  }
}));

export default useStyles;
